import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const ReceptaclesInPredesNotInPreconReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.RECEPTACLES_IN_PREDES_NOT_IN_PRECON_DETAILS.id,
        label: 'DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default ReceptaclesInPredesNotInPreconReport;

ReceptaclesInPredesNotInPreconReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  changeTrafficMode: PropTypes.func,
};
